import {
  CheckCircleIcon,
  CreditCardIcon,
  ShieldCheckIcon,
  TruckIcon,
  WrenchIcon
} from '@heroicons/react/20/solid';

const STAGE_TO_GROUP_MAP: Record<string, string> = {
  requested: 'Payment',
  paid: 'Payment',
  'production-started': 'Production',
  'production-completed': 'Production',
  'qa-started': 'QA',
  'qa-completed': 'QA',
  approved: 'QA',
  rejected: 'QA',
  sent: 'Delivery',
  delivered: 'Delivery'
};

const STAGE_LABELS: Record<string, string> = {
  requested: 'Order Requested',
  paid: 'Order Paid',
  'balance-paid': 'Balance Paid',
  'production-started': 'Production Started',
  'production-completed': 'Production Completed',
  'qa-started': 'Order QA Started',
  'qa-completed': 'Order QA Completed',
  approved: 'Approved for Shipping',
  rejected: 'Order QA Rejected',
  sent: 'Order Sent',
  delivered: 'Order Delivered'
};

const STAGE_ICONS: Record<string, JSX.Element> = {
  Payment: <CreditCardIcon className="w-5 h-5" />,
  Production: <WrenchIcon className="w-5 h-5" />,
  QA: <ShieldCheckIcon className="w-5 h-5" />,
  Delivery: <TruckIcon className="w-5 h-5" />
};

const STAGE_ICONS_SMALL: Record<string, JSX.Element> = {
  requested: <WrenchIcon className="w-4 h-4" />,
  paid: <WrenchIcon className="w-4 h-4" />,
  'production-started': <WrenchIcon className="w-4 h-4" />,
  'production-completed': <WrenchIcon className="w-4 h-4" />,
  'qa-started': <ShieldCheckIcon className="w-4 h-4" />,
  'qa-completed': <ShieldCheckIcon className="w-4 h-4" />,
  approved: <ShieldCheckIcon className="w-4 h-4" />,
  rejected: <ShieldCheckIcon className="w-4 h-4" />,
  sent: <TruckIcon className="w-4 h-4" />,
  delivered: <TruckIcon className="w-4 h-4" />
};

// Cavela Direct simplified timeline constants
const CAVELA_DIRECT_STAGE_TO_GROUP_MAP: Record<string, string> = {
  'order-placed': 'Order Placed',
  'supplier-confirmed': 'Supplier Confirmation',
  shipment: 'Shipment',
  delivered: 'Delivery'
};

const CAVELA_DIRECT_STAGE_LABELS: Record<string, string> = {
  'order-placed': 'Order Placed',
  'supplier-confirmed': 'Supplier Confirmed',
  shipment: 'Shipment',
  delivered: 'Delivered'
};

const CAVELA_DIRECT_STAGE_ICONS: Record<string, JSX.Element> = {
  'Order Placed': <CreditCardIcon className="w-5 h-5" />,
  'Supplier Confirmation': <CheckCircleIcon className="w-5 h-5" />,
  Shipment: <TruckIcon className="w-5 h-5" />,
  Delivery: <CheckCircleIcon className="w-5 h-5" />
};

const CAVELA_DIRECT_STAGE_ICONS_SMALL: Record<string, JSX.Element> = {
  'order-placed': <CreditCardIcon className="w-4 h-4" />,
  'supplier-confirmed': <CheckCircleIcon className="w-4 h-4" />,
  shipment: <TruckIcon className="w-4 h-4" />,
  delivered: <CheckCircleIcon className="w-4 h-4" />
};

export {
  CAVELA_DIRECT_STAGE_ICONS,
  CAVELA_DIRECT_STAGE_ICONS_SMALL,
  CAVELA_DIRECT_STAGE_LABELS,
  CAVELA_DIRECT_STAGE_TO_GROUP_MAP,
  STAGE_ICONS,
  STAGE_ICONS_SMALL,
  STAGE_LABELS,
  STAGE_TO_GROUP_MAP
};
